import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

export const containerStyling: AbgSxProps = {
  marginBottom: '26px',
};

export const itemStyling: AbgSxProps = {
  display: 'flex',
  marginBottom: '4px',
  gap: '4px',
};

export const titleStyling = (isIncluded: boolean): AbgSxProps => ({
  color: isIncluded ? paletteBase.black : paletteBase.neutral400,
  flex: '1 0 0',
  textDecoration: isIncluded ? 'none' : 'line-through',
});

export const priceStyling = (isHighlighted: boolean): AbgSxProps => ({
  color: isHighlighted ? paletteBase.semanticGreen : '',
});

export const iconContainerStyling: AbgSxProps = {
  width: '24px',
  display: 'flex',
  justifyContent: 'center',
};

export const infoIconStyling: AbgSxProps = {
  width: '18px',
};

export const tickIconStyling: AbgSxProps = {
  width: '16px',
  strokeWidth: '1px',
};

export const crossIconStyling: AbgSxProps = {
  width: '10px',
  strokeWidth: '1px',
};

export const snowflakeIconStyling: AbgSxProps = {
  width: '16px',
};
